import { useState } from "react";
import { navigateToDetail } from "../../Utils/utils";

export const RouteListItem = (props) => {
    const { route, linkText, redirectRoute, isOverview} = props
    const [detailIsOpen, setDetailIsOpen] = useState(false)

    const convertTypeToIcon = () => {
        let image = ""
        let baseUrl ="/images/listviewIcons"
        let suffix = ".svg"
        switch(route.type){
          case 9:
          case 25:
          case 26:
          case 49:
            image = `${baseUrl}/runIcon${suffix}`
            break;
          
          case 17:
          case 35:
          case 36:
            image=`${baseUrl}/horsebackIcon${suffix}`
            break;
          
          case 7:
            image=`${baseUrl}/mountainbikeIcon${suffix}`
            break;
  
          case 16:
          case 32:
            image=`${baseUrl}/kayakIcon${suffix}`
            break;
  
          case 19:
            image=`${baseUrl}/skateIcon${suffix}`
            break;
          case 2:
          case 8:
            image=`${baseUrl}/multiMoveIcon${suffix}`
            break;
        }
        return image
    }
    
    return(
        <div className={`c-routelistItem__container ${detailIsOpen ? '' : 'u-overflow'}`}>
            <img
                className="c-routelistItem__img"
                src={`${route.imageUrl}`}
            />
            <div className="c-routelistItem-routedetail__container">
              <h4 
                className="c-routelistItem-routedetail-content__big-text title" 
                  onClick={() => {setDetailIsOpen(!detailIsOpen)}}
              >
                {route.name}
              </h4>
              <div className="c-routelistItem-routedetail-content__container">
                <img 
                  className="c-routelistItem-routedetail__icon"
                  src={convertTypeToIcon(route.type)}
                />
                <p className="c-routelistItem-routedetail-content__big-text">&bull;</p>
                <p className="c-routelistItem-routedetail-content__big-text">{route.distance.toFixed(2)} km</p>
              </div>
              {route.description &&
                <p className={`${detailIsOpen ? 'c-routelistItem-routedetail__text2' : 'c-routelistItem-routedetail__text'}`}
                  dangerouslySetInnerHTML={{ __html: route?.description.substring(0, 250) + " ..."}}
                >
                </p>
              }
              {detailIsOpen ?
                <div className="c-routelistItem-routedetail-redirect__container">
                  <i className="fal fa-arrow-right"></i>
                  <a onClick={() => {
                    navigateToDetail(route.id, window, redirectRoute)}}>{linkText}</a>
                </div>
              :
                <></>
              }
            </div>
            <div 
              className="c-circle"
              onClick={() => {setDetailIsOpen(!detailIsOpen)}}  
            >
                <i className={`fal ${detailIsOpen ? 'fa-chevron-up': 'fa-chevron-down'}`}></i>
            </div>
        </div>
    );
}

